/**
 * 在菜品列表中，菜品类别条目的高度
 * （border+padding+margin+content）
 *  theme default
 */
const ITEM_DISH_TYPE_HEIGHT = 27;

/**
 * 在菜品列表中，菜品条目高度
 * （border+padding+margin+content）
 * theme default
 */
const ITEM_DISH_HEIGHT = 95;

/**
 * 在菜品列表中，优惠信息高度
 * （border+padding+margin+content）
 * line-height:15 padding:2px 0;
 * theme default
 */
const ITEM_DISH_DISCOUNT = 19;

/**
 * 优惠信息容器上外间距
 * theme default
 */
const ITEM_DISH_DISCOUNT_WRAPPER_MARGIN_TOP = 10;

/**
 *在菜品列表中，菜品类别条目的高度
 * （border+padding+margin+content）
 *  theme BIG
 */
const BIG_ITEM_DISH_TYPE_HEIGHT = 37;

/**
 * 在菜品列表中，菜品的高度
 * 图片的高度+价格信息的高度
 */
const BIG_ITEM_DISH_HEIGHT = document.documentElement.clientWidth * 0.34 + 100;

/**
 * 在菜品列表中，菜品类别条目的高度
 * （border+padding+margin+content）
 *  theme HUGE
 */
const HUGE_ITEM_DISH_TYPE_HEIGHT = 27;

/**
 * 在菜品列表中，菜品的高度
 * 图片的高度+价格信息的高度
 */
const HUGE_ITEM_DISH_HEIGHT = 15 + document.documentElement.clientWidth * 0.7 + 90;

/**
 * 没有会员价标签的高度
 */
const TEA_ITEM_DISH_HEIGHT_BASIC = 113;

/**
 * 会员价标签
 */
const TEA_ITEM_DISH_HEIGHT_MEMBER = 131;

/**
 * 会员活动
 */
const TEA_ITEM_DISH_HEIGHT_MEMBER_ACTIVITY = 129;

const TEA_ITEM_DISH_DISCOUNT_HEIGHT = 19;

export {
  ITEM_DISH_TYPE_HEIGHT,
  ITEM_DISH_HEIGHT,
  ITEM_DISH_DISCOUNT,
  ITEM_DISH_DISCOUNT_WRAPPER_MARGIN_TOP,
  BIG_ITEM_DISH_TYPE_HEIGHT,
  BIG_ITEM_DISH_HEIGHT,
  HUGE_ITEM_DISH_TYPE_HEIGHT,
  HUGE_ITEM_DISH_HEIGHT,
  TEA_ITEM_DISH_HEIGHT_BASIC,
  TEA_ITEM_DISH_HEIGHT_MEMBER,
  TEA_ITEM_DISH_HEIGHT_MEMBER_ACTIVITY,
  TEA_ITEM_DISH_DISCOUNT_HEIGHT,
};



// WEBPACK FOOTER //
// ./src/container/dish-scroller-menu/calcPosHelper.js